export const postPic = async (url, formdata) => {
    const options = {
        method: 'POST',
        body: formdata,
        cache: "no-cache"
    }
    const res = await fetch(url, options);
    return res;
}